export const useStaticImageQuery = groq`
*[_type == "staticImage" && currentPathname == $currentPathname][0] {
  _id,
  currentPathname,
  "cdnKey": image.asset._ref,
}
`;
